import React from 'react';
import PropTypes from 'prop-types';

import { withAppContext } from '../contexts/app';
import { withUser } from '../contexts/user';

import Button from 'shared/Button';
import Uploader from 'shared/uploader/ImageUploader';

import SegmentAnalytics from '../../../helpers/SegmentAnalytics.js';

class ImageUploader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false
    };
  }

  handleImageUploading = () => {
    this.setState({ uploading: true });
  }

  handleImageUpload = (image) => {
    this.setState({ uploading: false });
    this.props.onUpload(image);
  }

  handleImageUploadError = () => {
    this.setState({ uploading: false });
  }

  handlePhotoInstructionShown = () => {
    this.props.app.photoInstructionsShown = true;
  }

  handleButtonClick = () => {
    if (this.state.uploading) { return false; }
    SegmentAnalytics.track('Clicked image upload CTA', {
      cta: this.props.label
    });

    this.uploader.startUpload();
  }

  render() {
    const {
      app,
      className,
      icon,
      label,
      showSpinner,
      uploadingLabel
    } = this.props;

    const { uploading } = this.state;
    const buttonLabel = (uploading && uploadingLabel) ? uploadingLabel : label;
    const showInstructions = (this.props.showInstructions !== undefined) ? this.props.showInstructions : !app.photoInstructionsShown;

    // We also want to show dermoscopic instructions if the user is not logged in / is logged out
    const showDermoscopicInstructions = (!this.props.user.isLoggedIn || this.props.user.isClinician);

    return (
      <Uploader
        className={`image-uploader ${uploading ? 'disabled' : ''}`}
        ref={(c) => { this.uploader = c; }}
        onError={this.handleImageUploadError}
        onUploading={this.handleImageUploading}
        onUpload={this.handleImageUpload}
        onPhotoInstructionsShown={this.handlePhotoInstructionShown}
        showInstructions={showInstructions}
        showDermoscopicInstructions={showDermoscopicInstructions}
        showImageCropper={false}
        markAsUploadingOnSelection={true}
      >
        <Button
          className={`${className} image-uploader__button`}
          onClick={this.handleButtonClick}
          showSpinner={showSpinner && uploading}
        >
          {icon && <i className={`icon icon--${icon}`} />}
          {buttonLabel}
        </Button>
      </Uploader>
    );
  }
}

ImageUploader.defaultProps = {
  className: '',
  label: 'Upload a photo',
  uploadingLabel: 'Uploading...',
  showSpinner: true,
};

ImageUploader.propTypes = {
  app: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  showSpinner: PropTypes.bool,
  uploadingLabel: PropTypes.string,
  showInstructions: PropTypes.bool,
  onUpload: PropTypes.func, // Should be required. double-rendering?
  user: PropTypes.object.isRequired
};

export { ImageUploader };
export default withAppContext(withUser(ImageUploader));
